import { render, staticRenderFns } from "./DoctorCardOffer.vue?vue&type=template&id=69804fec&"
import script from "./DoctorCardOffer.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCardOffer.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69804fec')) {
      api.createRecord('69804fec', component.options)
    } else {
      api.reload('69804fec', component.options)
    }
    module.hot.accept("./DoctorCardOffer.vue?vue&type=template&id=69804fec&", function () {
      api.rerender('69804fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorCardOffer.vue"
export default component.exports